module.exports = __webpack_public_path__ + "img/serene_adventurer.ddf09c7f.png";